import { Component, ViewEncapsulation } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

@Component({
    selector: "nerri-service-worker",
    standalone: false,
    templateUrl: "service-worker.template.html",
    styleUrls: ["service-worker.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ServiceWorkerComponent {
    constructor(private updates: SwUpdate) {}

    public updateApp(): void {
        this.updates.activateUpdate().then(() => document.location.reload());
    }
}
